import React from 'react';
import './ProcessSelector.css';
import Tooltip from './Tooltip';

const categories = [
  { value: 'Пациент', label: 'Пациент' },
  { value: 'Врач', label: 'Врач' },
  { value: 'Мед.сестра', label: 'Мед.сестра' },
  { value: 'Мед.регистратор', label: 'Мед.регистратор' },
];

// products и actions будут фильтроваться по данным
function getProducts(data, category) {
  if (!category) return [];
  const set = new Set();
  data.forEach(row => {
    if (row[0] === category) set.add(row[1]);
  });
  return Array.from(set);
}

function getActions(data, category, product) {
  if (!category || !product) return [];
  const set = new Set();
  data.forEach(row => {
    if (row[0] === category && row[1] === product) set.add(row[2]);
  });
  return Array.from(set);
}

// Функция для получения описания способа
function getActionDescription(action) {
  const descriptions = {
    'В бумажную карту': 'ввод информации только на бумажном носителе',
    'В электронную карту': 'ввод информации только на электронном носителе',
    'В бумажную и в электронную': 'ввод информации на бумажном носителе с последующим дублированием на электронном носителе',
    'В электронную и в бумажную': 'ввод информации на электронном носителе с последующим выводом на бумажный носитель',
    // Дополнительные варианты для других действий
    'В бумажном виде': 'ввод информации только на бумажном носителе',
    'В электронном виде': 'ввод информации только на электронном носителе',
    'В бумажном и в электронном': 'ввод информации на бумажном носителе с последующим дублированием на электронном носителе',
    'В электронном и в бумажном': 'ввод информации на электронном носителе с последующим выводом на бумажный носитель',
    'Бумажную карту': 'подпись бумажного документа',
    'Электронную карту': 'подпись электронного документа',
    'Бумажную и электронную': 'подпись бумажного и электронного документов',
    'Электронную и бумажную': 'подпись электронного и бумажного документов'
  };
  return descriptions[action] || action;
}

const ProcessSelector = ({ filters, setFilters, data }) => {
  const handleChange = (key, value) => {
    // Сброс следующих фильтров при изменении предыдущего
    if (key === 'category') {
      setFilters({ category: value, product: '', action: '' });
    } else if (key === 'product') {
      setFilters(prev => ({ ...prev, product: value, action: '' }));
    } else {
      setFilters(prev => ({ ...prev, [key]: value }));
    }
  };

  // Получаем варианты продуктов и действий на основе выбранного
  const products = getProducts(data, filters.category);
  const actions = getActions(data, filters.category, filters.product);

  return (
    <div className="process-selector">
      <h2>Создание процесса</h2>
      <div className="selector-group">
        <div className="selector-label">Кто совершил действие</div>
        <div className="selector-options">
          {categories.map(cat => (
            <button
              key={cat.value}
              className={`selector-btn${filters.category === cat.value ? ' selected' : ''}`}
              onClick={() => handleChange('category', cat.value)}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>
      {filters.category && (
        <div className="selector-group fade-in">
          <div className="selector-label">Выберите действие</div>
          <div className="selector-options">
            {products.map(prod => (
              <button
                key={prod}
                className={`selector-btn${filters.product === prod ? ' selected' : ''}`}
                onClick={() => handleChange('product', prod)}
              >
                {prod}
              </button>
            ))}
          </div>
        </div>
      )}
      {filters.category && filters.product && (
        <div className="selector-group fade-in">
          <div className="selector-label">Выберите способ</div>
          <div className="selector-options">
            {actions.map(act => (
              <Tooltip
                key={act}
                content={getActionDescription(act)}
                position="top"
              >
                <button
                className={`selector-btn${filters.action === act ? ' selected' : ''}`}
                onClick={() => handleChange('action', act)}
              >
                {act}
              </button>
              </Tooltip>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProcessSelector; 